import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import logo from 'assets/images/logo/logo_white.png';

import { APIHandler, BackButton, DataHandler, Dropdown, SideMenu, StorageHandler, UserWidget } from 'config/C4';
import { storageKeys } from 'config/settings';

const accountToggleAnimation = {
  classNames: 'accountToggle',
  timeout: { enter: 250, exit: 250 },
};

const menuToggleAnimation = {
  classNames: 'menuToggle',
  timeout: { enter: 250, exit: 250 },
};

class Nav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: true,
      loggedIn: false,
      firstName: 'Login',
      lastName: '',
      menuToggle: false,
      accountToggle: false,
      lastCheckedMessages: '',
      unreadMessageCount: '',
    };

    this.handleMenuToggle = this.handleMenuToggle.bind(this);
    this.handleAccountToggle = this.handleAccountToggle.bind(this);
    this.checkForUnreadMessages = this.checkForUnreadMessages.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    this.mounted = true;

    this.init();
    this.checkForUnreadMessages();
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (window.scrollY < 15) this.setState({ show: true });
    else this.setState({ show: false });
  }

  handleMenuToggle() {
    this.setState(
      (prevState) => ({
        menuToggle: !prevState.menuToggle,
      }),
      () => {
        const container = document.getElementById('container');
        container.classList.remove('offsetContainer');
        window.scrollTo(0, 0);
      },
    );
  }

  handleAccountToggle() {
    this.setState(
      (prevState) => ({
        accountToggle: !prevState.accountToggle,
      }),
      this.checkForUnreadMessages,
    );
  }

  handleClickOutside() {
    this.setState({ menuToggle: false, accountToggle: false }, () => {
      const container = document.getElementById('container');
      if (container) container.classList.remove('offsetContainer');
    });
  }

  async checkForUnreadMessages() {
    const { unreadMessageCount, lastCheckedMessages } = this.state;
    const { missed_items: missedItems } = (await DataHandler.requestWithId(
      APIHandler.getUnreadMessages,
      lastCheckedMessages,
    )) || { missed_items: [{}] };

    const [{ count }] = missedItems;

    if (count !== undefined && count !== unreadMessageCount && this.mounted) {
      this.setState({ unreadMessageCount: count });
    }
  }

  async init() {
    const res = await StorageHandler.load(storageKeys.lastCheckedMessage);
    const { response: user } = (await StorageHandler.load(storageKeys.user)) || {};

    const newState = {};

    if (res) newState.lastCheckedMessages = res;

    if (user) {
      const { data } = (await DataHandler.requestWithId(APIHandler.getUserProgress, user.email)) || {};

      newState.loggedIn = true;
      newState.firstName = user.first_name;
      newState.lastName = user.last_name;
      newState.email = user.email;

      if (data) {
        const [{ chapters }] = data;
        newState.trainingComplete = chapters.every((chapter) => chapter.progress >= chapter.total_pages);
      }
    } else newState.loggedIn = false;

    if (this.mounted) {
      this.setState({ ...newState });
    }
  }

  render() {
    const {
      accountToggle,
      firstName,
      lastName,
      email,
      loggedIn,
      menuToggle,
      unreadMessageCount,
      trainingComplete,
      show,
    } = this.state;

    const { hasBackButton } = this.props;

    return (
      <nav>
        <div className="container__backButton">
          {hasBackButton && <BackButton withHistory={false} text={i18n.translate('general.back')} />}
        </div>
        {/* {window.location.pathname !== '/' && window.location.pathname !== '/main/'  && window.location.pathname !== '/main' && <img src={`https://front.travpromobile.com/${appId}/logo.png`} className="headerLogo" alt="logo" />} */}
        {show &&
          window.location.pathname !== '/' &&
          window.location.pathname !== '/main/' &&
          window.location.pathname !== '/main' && <img src={logo} className="headerLogo" alt="logo" />}
        <UserWidget
          handleAccountToggle={this.handleAccountToggle}
          accountToggle={accountToggle}
          firstName={firstName}
          loggedIn={loggedIn}
          unreadMessageCount={unreadMessageCount}
        />
        <TransitionGroup>
          {accountToggle && (
            <CSSTransition {...accountToggleAnimation}>
              <Dropdown
                handleClickOutside={this.handleClickOutside}
                outsideClickIgnoreClass="account"
                firstName={firstName}
                lastName={lastName}
                email={email}
                unreadMessageCount={unreadMessageCount}
                openSettings={this.openSettings}
                trainingComplete={trainingComplete}
                diploma={(src) => this.frame(src)}
              />
            </CSSTransition>
          )}
        </TransitionGroup>
        <TransitionGroup>
          {menuToggle && (
            <CSSTransition {...menuToggleAnimation}>
              <SideMenu
                handleClickOutside={this.handleClickOutside}
                outsideClickIgnoreClass="burgerMenu"
                firstName={firstName}
                lastName={lastName}
                email={email}
              />
            </CSSTransition>
          )}
        </TransitionGroup>
      </nav>
    );
  }
}

export default Nav;

Nav.propTypes = {
  pathname: PropTypes.string,
  hasBackButton: PropTypes.bool,
};

Nav.defaultProps = {
  pathname: '',
  hasBackButton: true,
};
